<template>
    <div class="ml_left">
        <temperature/>
        <div class="ma-top"></div>
        <waste/>
        <div class="ma-top"></div>
        <security/>
        <div class="ma-top"></div>
        <gas/>
    </div>
</template>

<script>
    import temperature from "./testing/temperature";
    import waste from "./testing/waste";
    import security from "./testing/security";
    import gas from "./testing/gas";
    export default {
        name: "testing",
        components: {
            temperature,
            waste,
            security,
            gas
        },
        data(){
            return{

            }
        }
    }
</script>

<style scoped lang="less">
    .ml_left {
        position: absolute;
        top: 10%;
        left: 2.5%;
        height: 84.5%;
        width: 15%;
        .ma-top{
            margin-top: 10%;
        }
    }
</style>